var ws = null;
let rec; //断线重连
let isConnect = false; //链接标识，避免重复连接
let connectCallBack = null;
let messageCallBack = null;
let closeCallBack = null;
let i = 0;
// let wsurl = window.GLOBAL.webSocket + "/allwebsocket/";
let wsurl = window.GLOBAL.webSocketAll;
import store from "../store/index";

let connect = () => {
  try {
    if (isConnect) {
      return;
    }
    // console.log("连接ws");
    ws = new WebSocket(wsurl);

    ws.onopen = function (e) {
      // console.log("ws连接成功");
      if (ws.readyState === WebSocket.OPEN) {
        isConnect = true;
        heartCheck.start();
        let heartBeat = {
          main_type: 1,
          utime: new Date(),
        };
        ws.send(JSON.stringify(heartBeat));
      }
      if (ws.readyState === WebSocket.CLOSED) {
        // console.log("ws连接异常，开始重连！");
        reconnect();
      }
    };

    ws.onmessage = function (e) {
      function isJson(str) {
        try {
          JSON.parse(str);
          return true;
        } catch (e) {
          return false;
        }
      }
      if (!isJson(e.data)) {
        return false;
      }
      let sendInfo = JSON.parse(e.data);
      store.commit("setWsData", sendInfo);
      localStorage.setItem("currencyAll", JSON.stringify(sendInfo));
      localStorage.setItem("isSyWs",true)
      // heartCheck.reset();
    };

    ws.onclose = function (e) {
      // console.log("ws连接关闭");
      isConnect = false;
      closeCallBack && closeCallBack(e);
    };

    ws.onerror = function () {
      // console.log("ws连接发生错误");
      isConnect = false;
      reconnect(wsurl);
    };
  } catch (e) {
    // console.log("尝试创建连接失败！");
    reconnect(wsurl);
  }
};

//重连间隔(暂时没用)
let retryCount = 0;
let maxRetry = 5;
let baseDelay = 1000;
let attemptReconnect = () => {
  if (retryCount < maxRetry) {
    const delay = Math.min(baseDelay * Math.pow(2, retryCount), 30000); //最大30秒
    setTimeout(() => {
      retryCount++;
      reconnect();
    }, delay);
  } else {
    // console.log("重连超过最大尝试次数！");
  }
};

//重连
let reconnect = (wsuri) => {
  // console.log("尝试重连！");
  if (isConnect) {
    return;
  }
  rec && clearTimeout(rec);
  rec = setTimeout(function () {
    connect();
  }, 1000);
};

//设置关闭连接
let close = (code) => {
  ws && ws.close();
};

//设置心跳
let heartCheck = {
  timeout: 20000,
  timeoutObj: null,
  serverTimeoutObj: null,
  timeIntervalObj: null,
  start: function () {
    clearInterval(this.timeIntervalObj);
    clearTimeout(this.serverTimeoutObj);
    this.timeIntervalObj = setInterval(() => {
      if (ws.readyState == 1) {
        //连接正常，心跳检测
        // console.log("ws连接正常，心跳检测");

        let heartBeat = {
          main_type: 1,
          utime: new Date(),
        };
        ws.send(JSON.stringify(heartBeat));
      } else {
        //
        this.serverTimeoutObj = setTimeout(() => {
          reconnect();
        }, 100);
      }
    }, this.timeout);
  },

  reset: function () {
    // console.log("重置心跳检测");
    clearInterval(this.timeIntervalObj);
    clearTimeout(this.serverTimeoutObj);
    clearTimeout(this.timeoutObj);
    this.timeoutObj = setTimeout(function () {
      heartCheck.start();
    }, 100);
  },
};

//实际调用方法
let sendMessage = (agentData) => {
  if (ws.readyState === ws.OPEN) {
    // ws开启状态
    ws.send(JSON.stringify(agentData));
  } else if (ws.readyState === ws.CONNECTING) {
    //正在开启状态，则等待1s后重新调用
    setTimeout(() => {
      sendMessage(agentData);
    }, 1000);
  } else {
    setTimeout(() => {
      sendMessage(agentData);
    }, 1000);
  }
};

let onConnect = (callback) => {
  connectCallBack = callback;
};
let onMessage = (callback) => {
  messageCallBack = callback;
};
let onClose = (callback) => {
  closeCallBack = callback;
};

export {
  connect,
  reconnect,
  close,
  sendMessage,
  onClose,
  onConnect,
  onMessage,
};



// WEBPACK FOOTER //
// ./src/utils/ws_service.js